import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Observable, debounceTime, filter, map, of, takeUntil, tap } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';

import { StripListHeaderComponent } from '@shared/components/strip-list/strip-list-header/strip-list-header.component';
import { StripListItemComponent } from '@shared/components/strip-list/strip-list-item/strip-list-item.component';
import { BasedComponent } from '@shared/components/based.component';
import { Driver } from '@app/shared/classes/driver';
import { ToggleButtonComponent, ToggleButtonType } from '@shared/components/toggle-button';
import { SearchDriversWithMyProfile } from '@app/shared/actions/common-data.action';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { NgxsActionName } from '@app/shared/constants';
import { WebApiResponse } from '@app/shared/classes/general';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-driver-search-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, StripListHeaderComponent, StripListItemComponent, ToggleButtonComponent, LoadingSpinnerComponent],
  templateUrl: './driver-search-grid.component.html',
  styleUrl: './driver-search-grid.component.css'
})
export class DriverSearchGridComponent extends BasedComponent {
  store = inject(Store);

  @Input() filterText$: Observable<string> = of('');
  @Output() itemToggled = new EventEmitter();

  ToggleButtonType = ToggleButtonType;
  selected: Driver;
  dataSource$: Observable<Driver[]>;

  @Select(AppDataState.taskResponse(NgxsActionName.SEARCH_DRIVERS_WITH_MY_PROFILE)) driverDataResponse$: Observable<WebApiResponse<Driver[]>>;
  @Select(AppDataState.taskExecuting(NgxsActionName.SEARCH_DRIVERS_WITH_MY_PROFILE)) processing$: Observable<boolean>;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    this.dataSource$ = this.driverDataResponse$.pipe(filter(res => res !== null && res !== undefined), map(res => res.data));
    this.filterText$.pipe(debounceTime(800), takeUntil(this.destroy$)).subscribe(filterText => {
      if (filterText) {
        this.selected = null;
      }

      if (filterText.length > 0) {
        this.store.dispatch(new SearchDriversWithMyProfile(filterText));
      }
    });
  }

  itemSelected = (item: Driver) => {
    this.selected = item;
    this.itemToggled.emit({ item: item, toggled: true });
    this.store.dispatch(new SearchDriversWithMyProfile());
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
